import React from 'react';
import styled from 'styled-components';

const Container = styled.svg`
  display: flex;
  fill: currentColor;
`;

export const ClockHand: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Container
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      className={className}
    >
      <path d="M29.67 7.53a1.537 1.537 0 00-2.982-.738L22.13 23.459a1.952 1.952 0 103.79.938L29.669 7.53z"></path>
    </Container>
  );
};
